import { EntityLinks, Goal, GoalType, ID } from '@griply/types';

import { getGoalTopLevelLifeAreas } from '../get-goal-life-area';
import { hasGoalParent } from './has-goal-parent';

export type LifeAreaGoalCounts = {
  goals: number;
  projects: number;
};

// A goal in two life areas counts toward both — totals across life areas are deliberately non-additive.
export const countGoalsByLifeArea = (
  goals: Goal[],
  links: EntityLinks,
): Record<ID, LifeAreaGoalCounts> => {
  const counts: Record<ID, LifeAreaGoalCounts> = {};
  const goalsById = new Map(goals.map((goal) => [goal.id, goal]));
  const cache = new Map<ID, ID[]>();

  goals.forEach((goal) => {
    if (goal.archivedAt || goal.completedAt) {
      return;
    }

    getGoalTopLevelLifeAreas(goal, {
      isNested: hasGoalParent(goal, { links }),
      goalsById,
      links,
      cache,
    }).forEach((lifeAreaId) => {
      const entry = counts[lifeAreaId] ?? { goals: 0, projects: 0 };
      // Untyped goals are regular goals, matching filterGoalsByType.
      if ((goal.type ?? GoalType.Goal) === GoalType.Project) {
        entry.projects += 1;
      } else {
        entry.goals += 1;
      }
      counts[lifeAreaId] = entry;
    });
  });

  return counts;
};
